import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewRelatedRoomTags from './viewRelatedRoomTags';
import viewRelatedSpaceThirdParty from './viewRelatedSpaceThirdParty';
export default {
  attributeName: 'room',
  isDragable: true,
  sortingPositionIndex: 'sortingIndex',
  orderIndex: 'desc',
  canChangePosition: true,
  canOpen: true,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  editId:'slug',
  editURL: routes.SPORT_ROOM_HOME_MAINHUB,
  // bulkSelectable:true,
  // bulkButtons:[
  //   {label:"Import sportroom",
  //   color:ButtonTheme.INFO,
  //   action:"bulkImport",
  //   actionUrl:"appConfig/bulkImport",
  //   type:BulkImportTypes.SPORTROOMCONFIG,
  //   title:"Import elements",
  //   showNumberElems:false,
  //   hidden:'never',
  //   sessionParams: ['appId'],
  //   formConfig:[
  //     {
  //       attributeName: 'type',
  //       helpText: 'Type of import',
  //       type: FormInputTypes.TEXT_INPUT.TEXT,
  //       required: true,
  //       label: 'Type',
  //       defaultValue:BulkImportTypes.SPORTROOMCONFIG,
  //       // hidden:true
  //     },
  //     {
  //       attributeName: 'config',
  //       helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
  //       type: FormInputTypes.SELECT,
  //       label: 'Config',
  //       placeholder: 'Please enter to add a valid config',
  //       multiple: false,
  //       disabledWhenEdit:true,
  //       url: 'appConfigslist/appId',
  //       // parentField:'app',
  //       enabledWhen:{"field":"app","notValues":['(Empty)']},
  //       emptyValue:true,
  //       // childField:'appCategories',
  //       default:'(Empty)', //default value to empty option
  //       allValue:'(All)',
  //       fieldValue:'id',
  //       fieldName:'name',
  //       asyncSelect: true,
  //       options:[],
  //       session: ['appId'],
  //     },
  //   ]
  // },
  //     {label:"Delete",
  //       color:ButtonTheme.ERROR,
  //       action:"bulkDelete",
  //       title:"Select records to delete",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     },
  //     {label:"Clone",
  //       color:ButtonTheme.DARK,
  //       action:"bulkClone",
  //       title:"Clone records",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     },
  //     {label:"Export",
  //       color:ButtonTheme.INFO,
  //       action:"bulkExport",
  //       title:"Export records",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     }],
  // isMultiSelectable:true,
  emptyMessage: "You don't have categories, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Name of the app.',
    },
    {
      attributeName: 'slug',
      label: 'Slug',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: true,
      canCreate: false,
      canOpen: true,
      canFilter: true,
      helpText: 'Slug of the app.',
    },
    {
      attributeName: 'appTags',
      label: 'Tags',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedRoomTags,
      filterByParticularId:{"field":"appId","value":"id"},
      default: [],
      helpText: 'Video categories joined.',
      exactWidth: '10rem',  
    },
    {
      attributeName: 'blockingProviders',
      label: 'Blocking Provider',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedSpaceThirdParty,
      default: [],
      helpText: 'Select the authentication provider required to access this MainHub.',
      exactWidth: '10rem',
    },
    {
      attributeName: 'sortingIndex',
      label: 'Index',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      default: [],
      // width: '3rem',
      exactWidth:'50px',
      small:true
    },
  ],
};
